import { BomItemImnooStatus } from '../components/ImnooEstimationStatus'
import { BomItemUpdateGridModel } from './BomItemUpdateGridModel'

export function BomItemGridName({
  row,
}: {
  row: Pick<BomItemUpdateGridModel, 'name' | 'bomItemPointer'>
}) {
  return (
    <div
      style={{
        padding: '0 1em',
        display: 'flex',
        alignItems: 'center',
        gap: '.5em',
      }}
    >
      <span>{row.name}</span>
      <BomItemImnooStatus bomItemPointer={row.bomItemPointer} compact />
    </div>
  )
}
